<template>
  <el-dialog
    v-model="dialogVisible"
    title="Настройка доступа к мессенджеру"
    width="500px"
    class="settings-modal settings-modal--compact"
    align-center
    :close-on-click-modal="false"
  >
    <el-select
      v-model="selectedUsers"
      multiple
      filterable
      placeholder="Выберите пользователей с доступом"
      style="width: 100%;">
      <el-option
        v-for="user in employees"
        :key="user.id"
        :label="user.name"
        :value="String(user.id)"
      />
    </el-select>
    <template #footer>
      <el-button @click="dialogVisible = false">Отмена</el-button>
      <el-button type="primary" @click="saveAccess">Сохранить</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'MessengerRolesDialog',
  props: {
    modelValue: Boolean,
    messengerId: [String, Number]
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedUsers: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    ...mapState('users', ['employees']),
    transferData() {
      return this.employees.map(user => ({
        key: String(user.id),
        label: user.name
      }));
    }
  },
  methods: {
    ...mapActions('messengers', ['updateMessengerAccess']),
    async saveAccess() {
      try {
        await this.updateMessengerAccess({
          messengerId: this.messengerId,
          allowed_user_ids: this.selectedUsers
        });
        this.$notify({ type: 'success', message: 'Настройки доступа сохранены' });
        this.dialogVisible = false;
      } catch (error) {
        this.$notify({ type: 'error', message: 'Ошибка при сохранении настроек' });
      }
    }
  }
};
</script>

<style scoped>
</style>
